import React from "react";
import { Navigate, useParams } from "react-router-dom";

export function ReceiptRedirect() {
  const { receipt_id } = useParams();
  return <Navigate to={`/admin/v2/receipts/${receipt_id}`} />;
}
